import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary">Return to Home</Link>
      </div>
    </div>
  );
};

export default NotFoundPage;